import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { PublicService } from '../../services/public.service';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, OnDestroy {
  //#region Declarations 
  isArabic: boolean = true;
  currentLanguage: string = '';
  arabInsLinks = [
    { name: 'footer.magazines', imgPath: "magazine.svg", routeTo: "/magazines" },
    // { name: 'footer.magazines', imgPath: "magazine.svg", routeTo: "/magazines" },
    { name: 'footer.newsLetter', imgPath: "news-letter-footer.svg", routeTo: '/news-letter/4' },
    { name: 'footer.careers', imgPath: "careers.svg", routeTo: '/careers' }
  ];

  contactUsLinks = [
    { name: 'footer.address', imgPath: "address.svg", descriptionAr: 'أولا : 10 شارع إيران الدقي - الجيزة <br> ثانيا: 8 شارع قصر النيل – القاهرة', descriptionEn: 'H.Q.: 10 Iran St - Dokki Giza <br> Giza Branch: 8 Kasr El Nil St Cairo A.R.E', },
    { name: 'footer.phone', imgPath: "phone.svg", descriptionAr: '+202 33380072 / +202 33380047', descriptionEn: '+202 33380072 / +202 33380047' },
    { name: 'footer.poBox', imgPath: "popox.svg", descriptionAr: "<span dir='rtl' >611  الرمز البريدي 11511  </span>", descriptionEn: '611 Cairo PC 11511' },
    { name: 'footer.email', imgPath: "mail.svg", descriptionAr: "gaif@gaif.org", descriptionEn: "gaif@gaif.org" },
    { name: 'footer.fax', imgPath: "fax.svg", descriptionAr: " +202 33380209", descriptionEn: " +202 33380209" }
  ];


  quickLinks: { name: string, routeTo: string | null, imgPath: string }[] = [
    {
      name: 'footer.home', imgPath: "footer-arrow.svg",
      routeTo: '/home'
    },
    {
      name: 'footer.aboutGAIF', imgPath: "footer-arrow.svg",
      routeTo: '/about'
    },
    {
      name: 'footer.gAIFOrganization', imgPath: "footer-arrow.svg",
      routeTo: '/general-conferences'
    },
    {
      name: 'footer.technicalCommittee', imgPath: "footer-arrow.svg",
      routeTo: '/committees-leagues'
    },
    {
      name: 'footer.gAIFMembers', imgPath: "footer-arrow.svg",
      routeTo: '/members'
    },
    {
      name: 'footer.milestones', imgPath: "footer-arrow.svg",
      routeTo: '/milestones'
    },
    {
      name: 'footer.insuranceLibrary', imgPath: "footer-arrow.svg",
      routeTo: '/insurance-library'
    },
    { name: 'footer.news', imgPath: "footer-arrow.svg", routeTo: '/news/2' },
    {
      name: 'footer.directory', imgPath: "footer-arrow.svg",
      routeTo: '/directory'
    }

  ];
  //#endregion

  //#region Constructor & injects
  publicService = inject(PublicService)
  translateService = inject(TranslateService)
  subscriptions = new Subscription();

  constructor() {
    this.subscriptions.add(this.translateService.onDefaultLangChange.subscribe((res) => {
      this.publicService.updateBodyDirection(res.lang)
      if (res) {
        this.currentLanguage = res.lang;
        this.isArabic = (res.lang === 'ar' ? true : false);
      }
    }))
  }

  //#endregion
  //#region Angular lifecycle 
  ngOnInit(): void {
    this.currentLanguage = this.publicService.getAppCurrentLanguage();
    this.isArabic = (this.currentLanguage === 'ar' ? true : false);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // https://www.instagram.com/generalarabinsurancefed/?igsh=amhlNHdlbm56eWN5
  // https://www.linkedin.com/company/general-arab-insurance-federation-gaif/
  //#endregion

}
